/**
 * Split elements into chunks
 * @param {Array} arr
 * @param {Number} len
 */

export default function chunk(arr, len) {
  const chunks = [];
  let iterator = 0;
  const arrLength = arr.length;

  while (iterator < arrLength) {
    chunks.push(arr.slice(iterator, iterator += len));
  }

  return chunks;
}
